// needed for react-ui and filters-v3
export var grayScale = {
  DEFAULT: "#B8B8B8",
  100: "#F4F5F5",
  200: "#EAEBEB",
  300: "#DADBDB",
  400: "#B8B8B8",
  500: "#929191",
  600: "#707070",
  700: "#575757",
  800: "#484848",
  900: "#333333",
  1000: "#1A1A1A"
};

// need before tree-shaking
export var redScale = {
  DEFAULT: "#E35B5B",
  100: "#FFF2F2",
  200: "#FDCFCF",
  300: "#FC9696",
  400: "#E35B5B",
  500: "#D13C3C",
  600: "#AC1818",
  700: "#8F000E",
  800: "#6B0000",
  900: "#540000",
  1000: "#330000"
};
